<div id="sidebar-user" class="offcanvas offcanvas-end">
  <div class="offcanvas-header mt-3">
    <div class="flex-grow-1">
      <h4 class="mb-0" i18n="@@NavTopMenuUserMenuTitle">User</h4>
    </div>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>

  <!-- user is not logged in -->
  @if (!loggedIn) {
    <div class="offcanvas-body">
      <ul class="list-group list-group-flush">
        <!-- display product list recently link, default is true -->
        @if (displayProductListRecentlyLink) {
          <a [routerLink]="['product', 'recently']" class="user list-group-item" data-bs-dismiss="offcanvas">
            <i class="bi bi-clock-history me-2"></i>
            <span i18n="@@NavTopMenuNavItemProductListRecently">Last seen</span>
          </a>
        }
        <a class="list-group-item" [routerLink]="['/login']" data-bs-dismiss="offcanvas">
          <i class="bi bi-box-arrow-in-right me-2"></i>
          <span i18n="@@NavTopMenuNavItemLogin">Login</span>
        </a>
      </ul>
    </div>
  }

  <!-- user is logged in -->
  @if (loggedIn) {
    <div class="offcanvas-body">
      <ul class="list-group list-group-flush">
        <!-- webshop user sidebar menu -->
        @if (webshopUserSidebarMenu) {
          <a class="user list-group-item" [routerLink]="['user']" data-bs-dismiss="offcanvas">
            <i class="bi bi-person-lines-fill me-2"></i>
            <span i18n="@@NavTopMenuNavItemPersonallyStatements">Personal statements</span>
          </a>
          <a class="user list-group-item" [routerLink]="['user', 'favorite']" data-bs-dismiss="offcanvas">
            <i class="bi bi-heart-fill me-2"></i>
            <span i18n="@@NavTopMenuNavItemFavorite">Favorites</span>
          </a>
          @if (isOrderCheckoutAllowed == true) {
            <a [routerLink]="['user', 'order-list']" class="user list-group-item" data-bs-dismiss="offcanvas">
              <i class="bi bi-receipt-cutoff me-2"></i>
              <span i18n="@@NavTopMenuNavItemOrderList">Order list</span>
            </a>
          }
          <!-- display offer list link -->
          @if (isOfferCheckoutAllowed == true) {
            <a [routerLink]="['user', 'offer-list']" class="user list-group-item" data-bs-dismiss="offcanvas">
              <i class="bi bi-tag-fill me-2"></i>
              <span i18n="@@NavTopMenuNavItemOfferList">Offer list</span>
            </a>
          }
          <a [routerLink]="['shopping-cart', 'management']" class="user list-group-item" data-bs-dismiss="offcanvas">
            <i class="bi bi-cart-fill me-2"></i>
            <span i18n="@@NavTopMenuNavItemShoppingCartManagement">Shopping cart management</span>
          </a>
          <!-- display product list recently link, default is true -->
          @if (displayProductListRecentlyLink) {
            <a [routerLink]="['product', 'recently']" class="user list-group-item" data-bs-dismiss="offcanvas">
              <i class="bi bi-clock-history me-2"></i>
              <span i18n="@@NavTopMenuNavItemProductListRecently">Last seen</span>
            </a>
          }
          @if (externalLinkList != undefined && externalLinkList.length > 0) {
            <app-external-links [linkList]="externalLinkList"></app-external-links>
          }
          <a class="user list-group-item" [routerLink]="anonymousLandingPage.routerlink" [queryParams]="anonymousLandingPage.queryParams" (click)="logout()" data-bs-dismiss="offcanvas">
            <i class="bi bi-box-arrow-right me-2"></i>
            <span i18n="@@NavTopMenuNavItemLogout">Logout</span>
          </a>
        }

        <!-- client portal sidebar menu -->
        @if (clientPortalUserSidebarMenu) {
          <a [routerLink]="['dashboard']" class="user list-group-item" data-bs-dismiss="offcanvas">
            <i class="bi bi-grid-fill me-2"></i>
            <span i18n="@@NavTopMenuNavItemDashboard">Dashboard</span>
          </a>
          @if (isOrderCheckoutAllowed == true) {
            <a [routerLink]="['user', 'order-list']" class="user list-group-item" data-bs-dismiss="offcanvas">
              <i class="bi bi-receipt-cutoff me-2"></i>
              <span i18n="@@NavTopMenuNavItemOrderList">Order list</span>
            </a>
          }
          <a [routerLink]="['price-lists']" class="user list-group-item" data-bs-dismiss="offcanvas">
            <i class="bi bi-list-ul me-2"></i>
            <span i18n="@@NavTopMenuNavItemPriceLists">Price lists</span>
          </a>
          <a [routerLink]="['contact-persons']" class="user list-group-item" data-bs-dismiss="offcanvas">
            <i class="bi bi-person-lines-fill me-2"></i>
            <span i18n="@@NavTopMenuNavItemContactPersons">Contact persons</span>
          </a>
          <a [routerLink]="['documents']" class="user list-group-item" data-bs-dismiss="offcanvas">
            <i class="bi bi-folder-fill me-2"></i>
            <span i18n="@@NavTopMenuNavItemDocuments">Documents</span>
          </a>
          <a class="user list-group-item" [routerLink]="['user']" data-bs-dismiss="offcanvas">
            <i class="bi bi-gear-fill me-2"></i>
            <span i18n="@@NavTopMenuNavItemPersonallyStatements">Personal statements</span>
          </a>
          <a [routerLink]="['statistics']" class="user list-group-item" data-bs-dismiss="offcanvas">
            <i class="bi bi-bar-chart-fill me-2"></i>
            <span i18n="@@NavTopMenuNavItemStatistic">Statistic</span>
          </a>
          <a class="user list-group-item" [routerLink]="anonymousLandingPage.routerlink" [queryParams]="anonymousLandingPage.queryParams" (click)="logout()" data-bs-dismiss="offcanvas">
            <i class="bi bi-box-arrow-right me-2"></i>
            <span i18n="@@NavTopMenuNavItemLogout">Logout</span>
          </a>
        }
      </ul>
    </div>
  }
</div>
